import { TextField, Table, TableHead, TableRow, TableCell, TableBody } from '@mui/material';
import React, { useState } from 'react';
import styles from './FullTimeScoreTable.module.scss';
import clsx from 'clsx';

interface Column {
  id: 'score' | 'coefficient';
  label: string;
  minWidth?: number;
  align?: 'right' | 'left' | 'center';
}

const columns: Column[] = [
  {
    id: 'score',
    label: 'Score',
    minWidth: 200,
    align: 'center',
  },
  {
    id: 'coefficient',
    label: 'Frequency coefficient',
    minWidth: 200,
    align: 'center',
  }
]

type FullTimeScoreTablePropsType = {
  data: any;
  handleChangeCoefficient: (
    frequenciesTable: { score: string, coefficient: number }[],
    defaultFrequencyCoefficient: number
  ) => void;
}

export const FullTimeScoreTable = ({ data, handleChangeCoefficient }: FullTimeScoreTablePropsType) => {
  const [fullTimeScoreData, setFullTimeScoreData] = useState(data);
  const [otherScoreValue, setOtherScoreValue] = useState(fullTimeScoreData.defaultFrequencyCoefficient);
  
  const handleChangeCoefficients = (value: any, indexNumber: number, keyName: any) => {
    const updatedData = fullTimeScoreData.frequencies.map((item: any, index: number) => {
      if (indexNumber === index) {
        if (keyName === 'coefficient') return {...item, coefficient: Number(value)}
      }
      return item;
    });
    
    setFullTimeScoreData({...data, frequencies: updatedData});
    handleChangeCoefficient(updatedData, fullTimeScoreData.defaultFrequencyCoefficient);
  };
  
  return (
    <div className={styles.fullTimeScoreContainer}>
      <Table stickyHeader aria-labelledby="simple table" size={"small"} className={styles.table}>
        <TableHead>
          <TableRow>
            {columns.map((column) => (
              <TableCell
                key={column.id}
                align={column.align}
                style={{ minWidth: column.minWidth }}
                className={styles.columnTitle}
              >
                {column.label}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {fullTimeScoreData.frequencies.map((row: any, index: number) => {
            return (
              <TableRow hover tabIndex={-1} key={index.toString()}>
                {columns.map((column) => {
                  return (
                    <TableCell key={column.id} align={column.align}>
                      {column.id === 'score' ? row[column.id] : (
                        <TextField
                          id={`${row[column.id].key}_${index.toString()}`}
                          value={Number(row[column.id]).toString()}
                          type="number"
                          onChange={(e) =>
                            handleChangeCoefficients(e.target.value, index, column.id)
                          }
                          className={clsx(styles.inputTable, Number(row[column.id]) <= 0 && styles.errorInput)}
                        />
                      )}
                    </TableCell>
                  );
                })}
              </TableRow>
            );
            })}
        </TableBody>
      </Table>
      <div className={styles.otherScoresContainer}>
        <span>Other scores up to 9:9</span>
        <TextField
          type="number"
          value={Number(otherScoreValue).toString()}
          onChange={(e) => {
            setOtherScoreValue(e.target.value);
            handleChangeCoefficient(fullTimeScoreData.frequencies, Number(e.target.value));
          }}
          id="frequency_coefficient_other"
          label="Frequency coefficient"
          variant="standard"
          className="!ml-20"
          error={Number(otherScoreValue) <= 0}
          helperText={Number(otherScoreValue) <= 0 ? "Must be a positive number" : ' '}
        />
      </div>
    </div>
  )
}